import { QueryClientProvider } from '@w/react-query'
import { PlatformShell } from '@w/ui/system/platform-shell'
import { LocalStorageProvider } from '@w/utils-fe'
import type { PropsWithChildren } from 'react'
import { useRouterContext } from '../router/flashcards-fe.router-bindings'
import { I18nProvider } from '../i18n'
import { App } from './app'
import { getThemeStorageKey } from './theme-storage'
export { getThemeStorageKey } from './theme-storage'
import { LoadingSpinner } from './loading-spinner'

const AppSuspenseFallback = <LoadingSpinner />

export function BaseShell({ children }: PropsWithChildren) {
  const { auth } = useRouterContext()
  const themeStorageKey = getThemeStorageKey(auth.getUserOrNull()?.id)

  return (
    <PlatformShell
      themeStorageKey={themeStorageKey}
      suspenseFallback={AppSuspenseFallback}
    >
      <FlashcardsAppShell>{children}</FlashcardsAppShell>
    </PlatformShell>
  )
}

/** Flashcards-only providers. Requires router ctx; safe inside shared host shell. */
export function FlashcardsAppShell({ children }: PropsWithChildren) {
  const { queryClient, localStorage } = useRouterContext()

  return (
    <LocalStorageProvider storage={localStorage}>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <App>{children}</App>
        </QueryClientProvider>
      </I18nProvider>
    </LocalStorageProvider>
  )
}
